<div class="container">
  <div class="row">
    <div class="col-sm text-center">
      <img src="https://cdn.ecotree.fr/assets/img/logo/logo_ecotree_sans-slogan.svg" width="100" alt="logo">
    </div>
  </div>

  <form [formGroup]="form" class="col-md">
    <div class="input-group sm-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="inputGroupFileAddon02">
          <mdb-icon fas icon="map-signs" class="prefix"></mdb-icon>
        </span>
      </div>
      <div class="custom-file">
        <input formControlName="files" type="file" multiple (change)="onFileChange($event)" class="custom-file-input"
          id="inputGroupFile01" aria-describedby="inputGroupFileAddon02">
        <label class="custom-file-label" for="inputGroupFile01">
          Choisir les fichier de cartographie et de contrôle du robot
        </label>
      </div>
    </div>

    <br>
    <div *ngIf="f.files.touched && f.files.invalid" class="alert alert-danger">
      <div *ngIf="f.files.errors.required">Les fichiers sont obligatoires.</div>
      <div *ngIf="f.files.errors?.length">Le nombre de fichiers doit être de 2.</div>
    </div>
    <ul *ngIf="f.files.touched && f.files.valid">
      <li *ngFor="let file of files">
        <code>
        {{ file['name'] }}
      </code>
      </li>
    </ul>

    <br>
    <button type="button" class="btn btn-primary" (click)="launchMrRobot()" [disabled]="f.files.untouched || f.files.invalid">
      <i class="fas fa-truck-monster pr-2" aria-hidden="true"></i>Lancer l'exécution !
    </button>
  </form>
</div>